const autoNgTemplateLoaderTemplate1 = require('./node-details-view.html');

angular.module('shbdeployer.docker').component('nodeDetailsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'NodeDetailsViewController',
  bindings: {
    endpoint: '<',
  },
});
